<<template>
  <div>
    <header class="fixed w-full top-0 z-40 py-4 px-6 bg-black/50 backdrop-blur-sm">
      <div class="max-w-7xl mx-auto flex justify-between items-center">
        <!-- Left side: Logo -->
        <div class="flex items-center">
          <img src="/icon.png" alt="Ploppin Logo" class="w-12 h-12 rounded-2xl" />
        </div>

        <!-- Center: Navigation -->
        <nav class="hidden md:flex items-center space-x-8">
          <NuxtLink 
            v-for="item in navItems" 
            :key="item.path"
            :to="item.path"
            class="text-gray-300 hover:text-white transition-colors"
          >
            {{ item.name }}
          </NuxtLink>
        </nav>

        <!-- Right side: Auth & Credits -->
        <div class="flex items-center gap-4">
          <!-- Auth Buttons -->
          <template v-if="isAuthenticated">
            <NuxtLink 
              to="/app"
              class="font-bold text-white border-2 border-white hover:bg-white hover:text-black rounded px-4 py-1 transition-colors"
            >
              Go To App
            </NuxtLink>
          </template>
          <template v-else>
            <NuxtLink 
              to="/login"
              class="font-bold text-white border-2 border-white hover:bg-white hover:text-black rounded px-4 py-1 transition-colors"
            >
              login
            </NuxtLink>
          </template>
        </div>
      </div>
    </header>

    <LoginDialog 
      :is-open="isDialogOpen" 
      @close="isDialogOpen = false" 
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAuth } from '~/composables/useAuth'
import { useRoute } from 'vue-router'

const { isAuthenticated, logout } = useAuth()
const isDialogOpen = ref(false)
const route = useRoute()

// Navigation items
const navItems = [
  { name: 'Home', path: '/' },
  { name: 'Pricing', path: '/#pricing' },
  { name: 'FAQ', path: '/#faq' }
]
</script>

<style scoped>
/* Custom color variables */
:root {
  --navy: #0f172a;
  --navy-800: #1e293b;
  --navy-700: #334155;
  --navy-600: #475569;
}

.group:hover .group-hover\:opacity-100 {
  opacity: 1 !important;
}
</style>>